import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import PageInFlowNoSidebarLayout from 'components/common/general/layouts/PageInFlowNoSidebarLayout';
import { QuoteRouteV2Id } from 'routes/routesConfigV2';
import { buildGroupContextMoreInfoBlobProps } from 'components/common/group/GroupContextMoreInfoBlob';
import { MedicalCategoryCard } from 'components/common/subscriber/imq/health-questionnaire/MedicalCategoryCard';
import { ManageConditionsModal } from 'components/common/subscriber/imq/health-questionnaire/ManageConditionsModal';
import { HealthQuestionnaireLayout } from 'components/common/subscriber/imq/health-questionnaire/HealthQuestionnaireLayout';
import { useImqBrokerHealthQuestionnairePageStore } from 'store/pages/quote/imq-add-employees/health-questionnaire/pageStore';

export const PageContent: React.FC = observer(() => {
  const {
    getFlowAndPageInitialData,
    isInitialLoading,
    isActionLoading,
    flowDelegate,
    domainParams,
    subscriberImqModule,
    editCategory,
    onManageCondition,
    manageConditionModalDelegate,
    completeChecklistStep,
    canComplete,
    isStepCompleted,
  } = useImqBrokerHealthQuestionnairePageStore();

  useEffect(() => {
    void getFlowAndPageInitialData();
  }, []);

  return (
    <>
      <PageInFlowNoSidebarLayout
        contentWidth="standard"
        domainParams={{ ...domainParams }}
        pageId={QuoteRouteV2Id.IMQ_ADD_EMPLOYEES_HEALTH_QUESTIONNAIRE}
        isInitialLoading={isInitialLoading}
        isActionLoading={isActionLoading}
        isInfoSectionLoading={flowDelegate.isFlowDataLoading}
        moreInfoBlob={
          flowDelegate.groupInfoDelegate.moreInfoBlobInput
            ? buildGroupContextMoreInfoBlobProps(flowDelegate.groupInfoDelegate.moreInfoBlobInput)
            : undefined
        }
        pageHeader={{
          subtitle: subscriberImqModule.categoriesProgressText,
        }}
        pageFooter={{
          onComplete: completeChecklistStep,
          completeButtonText: isStepCompleted ? 'Update' : 'Complete',
          disableCompleteButton: !canComplete,
        }}
      >
        <HealthQuestionnaireLayout>
          {subscriberImqModule.medicalCategories.map((category) => {
            const categoryName = category.name;

            return (
              <MedicalCategoryCard
                key={categoryName}
                name={categoryName}
                status={category.status}
                conditions={category.reportedConditions ?? []}
                editCategory={(): void => editCategory(categoryName)}
                manageCondition={(condition, affectedPeople): void =>
                  onManageCondition(categoryName, condition, affectedPeople)
                }
              />
            );
          })}
        </HealthQuestionnaireLayout>
      </PageInFlowNoSidebarLayout>
      <ManageConditionsModal manageConditionModalDelegate={manageConditionModalDelegate} />
    </>
  );
});
